import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vnd-per-cny',
  templateUrl: './vnd-per-cny.component.html',
  styleUrls: ['./vnd-per-cny.component.scss']
})
export class VndPerCnyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
